<template>
  <div class="use_detail">
  <h4>(一)百度系定向流量包：</h4>
 <p> 应用包含：手机百度、百度贴吧、百度地图、爱奇艺视频、百度网盘（超级会员）、百度手机助手、百度百科、秒懂百科、百度知道、百度文库、百度输入法、地图淘金、百度糯米、千千音乐、百度翻译、百度新闻、百度浏览器、好看视频。</p>
 <p>（其中：手机百度、百度网盘、百度手机助手、百度新闻、百度浏览器、好看视频享受免流服务前需先至对应APP进行绑定激活）</p>
<p> 绑定入口：手机百度：【个人中心】-【免流量特权】-【活动页面】-【激活免流】</p>
<p> 百度网盘：【更多】-【设置】-【免流量特权】-【活动页面】-【激活免流】（只限百度网盘会员绑定激活免流，非会员无法免流）</p>
<p> 百度手机助：【管理】-【免流量服务】-【活动页面】-【激活免流】</p>
<p> 好看视频：【我的】-【免流特权】-【活动页面】-【激活免流】</p>
<p> 注：以上需绑定激活的应用（除百度网盘APP），在同一手机终端使用时，只需激活其中一款应用，其他应用无需绑定激活即可享受免流服务。
好看视频吉林、浙江暂不免流。</p>

<h4>1.爱奇艺视频定向流量使用说明：</h4>
<p>爱奇艺视频定向免流量范围：</p>
<p> 1)VIP版块以及视频频道内容观看(含片头、片中视频广告)，视频弹幕加载。</p>
<p> 2)漫画以及文学频道</p>
<p>爱奇艺视频定向流量不包括以下使用范围：</p>
<p>1)VR/3D视频、泡泡圈、乐活商城、乐活直播、视频购，第三方视频，视频缓存和内容上传，H5广告页面等。其中乐活直播和泡泡圈实际流量免费，但目前提示流量，介意的朋友勿用。</p>
<p>2)在无线上网卡、移动WIFI、MIFI、平板电脑（如ipad）等设备使用。</p>
<p>3)手机号码作为手机热点使用。</p>
  
<h4>2.手机百度定向流量使用说明：</h4>
<p>免流涵盖：</p>
<p>1)通过搜索（试用版）打开并跳转的网页；</p>
<p>2)个性化资讯推荐板块(基本全部免流，动漫、逛逛、畅听以及少部分第三方小说不免流；广告不免流)；</p>
<p>3)其他用户自主进入频道(右上方)，小说观看文字和在线高质量阅读(个别第三方内容有提示不免流)。</p>
<p>免流不包括：</p>
<p>1)通过搜索（试用版）打开的以下内容：</p>
<p>a)通过搜索打开的所有音频文件；</p>
<p>b)通过搜索进行下载的文件、图片、音频、手机应用（调起前往百度助手下载的除外）等下载类目；</p>
<p>c)其中苹果系统IOS11以下(不包含IOS11)不在免流范围内；</p>
<p>2)其他用户自主进入频道(右上方)音乐、地图、糯米等。</p>

<h4>3.百度网盘定向流量使用说明：</h4> 
<p>1)免流涵盖：手动上传、下载、文件预览功能；</p>
<p>2)免流不包括：看吧、美图、应用备份、推荐应用下载、更多工具、广告、视频播放插件安装、皮肤下载、云冲印、图片修图等；百度网盘非超级会员用户，无法享受百度网盘APP的“专属流量”特权。
</p> 
<h4>4.百度地图定向流量使用说明：</h4> 
<p>1)免流涵盖：搜索、定位、导航、查看地图</p>
<p>2)免流不包括：除搜索、定位、导航、查看地图以外的功能，暂不免流，例如：共享单车版块和车主服务版块以及周边内的所有内容。
</p> 
<h4>5.百度贴吧定向流量使用说明：</h4> 
<p>1)免流涵盖：搜索、刷贴吧(图片、文字)、发视频、发直播、观看直播。</p>
<p>2)免流不包括：刷贴吧视频和第三方图片，广告以及第三方链接。</p>
<p>注：另除浏览，发帖，搜索，直播以外内容暂时不免流。例如：贴吧里的书城。
</p> 
<h4>6.好看视频定向流量使用说明：</h4> 
<p>1)免流涵盖：涵盖好看视频内容播放、搜索、上传、下载等主要功能。</p>
<p>2)免流不包括：第三方视频播放、第三方广告及活动等。
</p> 
<h4>7.百度手机助手定向流量使用说明：</h4> 
<p>1)免流涵盖：所有百度手机助手中搜索、下载应用免流。</p>
<p>2)免流不包括：第三方提供的视频、图片、广告、应用下载等，以及跳转至助手App外其他应用产生的流量。
</p> 
<h4>8.百度百科定向流量使用说明：</h4> 
<p>1)免流涵盖：涵盖词条、文章浏览，以及视频播放、上传主要功能。百度百科App需达到3.0.2及以上版本才可享受免流服务。
</p>
<p>2)免流不包括：少量第三方视频播放、第三方购票功能。
</p> 
<h4>9.秒懂百科定向流量使用说明：</h4> 
<p>1)免流涵盖：涵盖视频播放、搜索、上传主要功能。秒懂百科App需达到1.0.0及以上版本才可享受免流服务。
</p>
<p>2)免流不包括：少量第三方视频播放、第三方活动。
</p> 
<h4>10.百度知道定向流量使用说明：</h4> 
<p>1) 免流涵盖：百度知道APP内所有内容均可免流使用。百度知道App需达到8.1.0及以上版本才可享受免流服务。
</p> 
<h4>11.百度文库定向流量使用说明：</h4> 
<p>1) 免流涵盖：百度文库APP内所有内容均可免流使用。百度文库App需达到4.3.5及以上版本才可享受免流服务。
</p> 
<h4>12.百度输入法定向流量使用说明：</h4> 
<p>1) 免流涵盖：涵盖语音输入、皮肤下载、表情下载主要功能。百度输入法App需达到8.0及以上版本才可享受免流服务。
</p>
<p>2) 免流不包括：卡片搜索、精品推荐应用下载、内置浏览器。
</p> 
<h4>13.地图淘金定向流量使用说明：</h4> 
<p>1)免流涵盖：地图淘金内除活动专区少量第三方活动外的所有内容。地图淘金App需达到4.7.1及以上版本才可享受免流服务。
</p>
<p>2)免流不包括：活动专区内的少量第三方活动。
</p> 
<h4>14.百度糯米定向流量使用说明：</h4> 
<p>1)免流涵盖：2G/3G/4G网络下，使用手机APP产生的国内流量免费。百度糯米App需达到8.1.0及以上版本才可享受免流服务。
</p>
<p>2)免流不包括：第三方提供的广告、服务等。</p> 

<h4> 15.千千音乐定向流量使用说明：</h4>
<p>1) 免流涵盖：千千音乐APP内所有内容均可免流使用。千千音乐App需达到6.1.0.3及以上版本才可享受免流服务。
</p> 
<h4>16.百度翻译定向流量使用说明：</h4> 
<p>1)免流涵盖：文字翻译、小应用等功能。百度翻译App需达到7.5.3及以上版本才可享受免流服务。
</p>
<p>2)免流不包括：第三方提供的广告。
</p> 
<h4>17.百度新闻定向流量使用说明：</h4> 
<p>1)免流涵盖：百度新闻内新闻板块的所有新闻频道、智库板块。百度新闻App需达到7.0.4及以上版本才可享受免流服务。
</p>
<p>2)免流不包括：订阅板块中接入的新浪微博、虎嗅及第三方内容。
</p> 
<h4>18.百度浏览器定向流量使用说明：</h4> 
<p>1)百度浏览器专属流量范围。</p>
<p>a) 通过搜索打开的网页</p>
<p>2)免流不包括：</p>
<p>a) 通过搜索（试用版）打开的以下内容：</p>
<p>i.通过搜索打开的所有音频文件；</p>
<p>ii.通过搜索进行下载的文件、图片、音频、手机应用（调起前往百度助手下载的除外）等下载类目；</p>
<p>iii.其中苹果系统IOS11以下(不包含IOS11)不在免流范围内；</p>
<p>b) 首页除【百度】外的所有频道都不包含在免流范围内；</p>

<h4>19.快手APP、快手极速版APP定向流量使用说明：</h4> 
<p>&nbsp;&nbsp;当您使用此产品，访问快手APP或快手极速版APP，在"看直播、看短视频及看图集/长图等图片资源"时产生的流量均可免费。
</p>
<p>&nbsp;&nbsp;其中，使用"评论|消息等文本信息、音乐|K歌，直播礼物加载，上传视频|图片，观看第三方提供的广告、网页浏览等服务"产生的流量，不在专属流量范围内。
</p>
<p>特殊说明：</p>
<p>1)使用免流服务需升级至快手客户端至iOS 5.6.0.398及以上版本、Android 5.6.2.5992及以上版本 ；</p>
<p>2)在无线上网卡、移动WIFI、MIR、平板电脑等设备不支持免流；</p>
<p>3)手机号码作为手机热点时，不支持免流；</p>
<p>4)使用网络加速器、代理服务器、VPN等工具无法免流 ；</p>
<p>5)在国际或中国港澳台地区使用客户端不支持免流；</p>
<p>注：在中国电信2G/3G/4G网络下，通过您办理的免流卡或包访问快手/快手极速版，系统可在48小时内自动启用免流服务；免流服务启用后，可在菜单中查看状态，具体入口为：设置菜单（首页左上角）-免流服务-已启用。</p>

<h4>(二)网易系定向流量包</h4> 
<p>应用包含：</p>
<p>网易系非游戏应用：网易云音乐、网易新闻、网易公开课、网易云阅读、网易云课堂、易信、网易蜗牛阅读、网易100分</p>
<p>网易系游戏应用包含：梦幻西游、大话西游、阴阳师、荒野行动、终结者2、倩女幽魂、率土之滨、镇魔曲、三国如龙传、坦克连、元气战姬学院、迷雾世界、大航海之路、汉王纷争、决战平安京、我的世界、天下、光明大陆、玩具大乱斗、格罗娅传奇</p>

<p>网易系非游戏类应用免流范围：</p>
<h4>1.网易云音乐免流范围：</h4>
<p>电信2G/3G/4G网络下，使用网易云音乐手机APP的流量免费。</p>
<p>专属免流量不包括以下使用范围：</p>
<p>1)iOS和安卓客户端版本低于4.3.1版本不免流（不包含4.3.1）。</p>
<p>2)客户端启动广告、其他部分客户端广告、客户端内的直播业务的流量；</p>
<p>3)APP内添加并关注微博、微信等好友；客户端内分享到其他APP；动态、私信等打开第三方链接；</p>
<p>4)第三方APP访问网易云音乐产生的流量不免流，如微博、微信内播放网易云音乐的音频、视频等；</p>
<p>5)手机号码处于国际或港澳台地区漫游状态下产生的流量；</p>
<p>6)手机卡作为手机热点使用，或使用网络加速器、代理服务器、VPN等工具；</p>
<p>7)在无线上网卡、移动WIFI、MIFI、平板电脑（如iPad）等设备使用不免流量；</p>
<p>8)使用非iPhone、非android版本的客户端APP（如WindowsPhone）产生的流量；</p>
<p>9)双卡用户切换到其他手机卡使用流量；</p>
<p>10)iPhone用户需要关闭无线局域网助理（设置路径：设置-蜂窝移动网络-无线局域网助理）。</p>
<h4>2.网易新闻免流范围：</h4>
<p>网易新闻定向流量范围：电信4G、3G、2G网络下，网易新闻客户端内的流量免费。</p>
<p>网易新闻定向流量不包括以下使用范围：</p>
<p>1)网易新闻直播类视频，在线观看、下载、缓存第三方视频等操作。</p>
<p>2)网易新闻客户端下载、缓存、上传视频均不在定向流量减免范围之内。</p>
<p>3)在无线上网卡、移动WIFI、MIFI、平板电脑（如ipad）等设备使用。</p>
<p>4)手机号码作为手机热点使用。</p>
<h4>3.网易公开课免流范围：</h4>
<p>电信2G/3G/4G网络下，使用网易公开课手机APP的流量免费。</p>
<p>专属免流量不包括以下使用范围：</p>
<p>1)ios和安卓客户端版本低于5.2.5版本不免流（不包含5.2.5）。</p>
<p>2)客户端启动广告、评论跟帖、客户端内的直播业务的流量；</p>
<p>3)APP内添加并关注微博、微信好友，APP内分享网易公开课到站外，APP内打开第三方链接；</p>
<p>4)第三方APP访问网易公开课产生的流量不免流，如微博、微信内播放网易公开课的音频、视频等；</p>
<p>5)手机号码处于国际或港澳台地区漫游状态下产生的流量；</p>
<p>6)手机卡作为手机热点使用，或使用网络加速器、代理服务器、VPN等工具；</p>
<p>7)在无线上网卡、移动WIFI、MIFI、平板电脑（如ipad）等设备使用不免流量；</p>
<h4>4.网易云课堂免流范围：</h4>
<p>电信2G/3G/4G网络下，使用网易云课堂APP基本功能流量免费。</p>
<p>专属免流量不包括以下使用范围：</p>
<p>1)APP客户端开机广告和客户端内其他广告产生的流量；</p>
<p>2)应用中访问外部链接或转发到外部应用产生的流量；</p>
<p>3)APP内直播业务均不免流；</p>
<p>4)上传、评论产生的流量。</p>
<h4>5.网易蜗牛阅读免流范围：</h4>
<p>网易蜗牛读书 "电信2G/3G/4G网络下，使用网易蜗牛读书APP的流量免费。</p>
<p>专属免流量不包括以下使用范围：</p>
<p>1)iOS和安卓客户端版本低于1.3.3版本不免流（不包含1.3.3）；</p>
<p>2)客户端启动广告、其他部分客户端广告、客户端内的直播业务的流量；</p>
<p>3)APP内添加并关注微博、微信等好友；客户端内分享到其他APP；动态、私信打开第三方链接；</p>
<p>4)第三方APP访问网易蜗牛读书产生的流量不免流，如微博、微信内观看蜗牛读书的内容等；</p>
<p>5)评论上传不免流；</p>
<p>6)手机号码处于国际或港澳台地区漫游状态下产生的流量；</p>
<p>7)手机卡作为手机热点使用，或使用网络加速器、代理服务器、VPN等工具；</p>
<p>8)在无线上网卡、移动WIFI、MIFI、平板电脑（如iPad）等设备使用不免流量；</p>
<p>9)使用非iPhone、非android版本的客户端APP（如WindowsPhone）产生的流量；</p>
<p>10)双卡用户切换到其他手机卡使用流量；</p>
<p>11)iPhone用户需要关闭无线局域网助理（设置路径：设置-蜂窝移动网络-无线局域网助理）。</p>
<h4>6.网易100分免流范围：</h4>
<p>电信2G/3G/4G网络下，使用网易100分的流量免费。</p>
<p>专属免流量不包括以下使用范围：</p>
<p>1)iOS和安卓客户端版本低于1.7.5版本不免流（不包含1.7.5）;</p>
<p>2)客户端启动广告、其他部分客户端广告、客户端内的直播业务的流量；</p>
<p>3)APP内添加并关注微博、微信、易信等好友；客户端内分享到其他APP；动态、私信等打开第三方链接；</p>
<p>4)第三方APP访问网易100分产生的流量不免流，如微博、微信内观看网易100分的内容等；</p>
<p>5)评论上传不免流；</p>
<p>6)手机号码处于国际或港澳台地区漫游状态下产生的流量；</p>
<p>7)手机卡作为手机热点使用，或使用网络加速器、代理服务器、VPN等工具；</p>
<p>8)在无线上网卡、移动WIFI、MIFI、平板电脑（如iPad）等设备使用不免流量；</p>
<p>9)使用非iPhone、非android版本的客户端APP（如WindowsPhone）产生的流量；</p>
<p>10)双卡用户切换到其他手机卡使用流量；</p>
<p>11)iPhone用户需要关闭无线局域网助理（设置路径：设置-蜂窝移动网络-无线局域网助理）。</p>
<h4>7.网易云阅读免流范围：</h4>
<p>电信2G/3G/4G网络下，使用APP的流量免费。</p>
<p>专属免流量不包括以下使用范围：</p>
<p>1)iOS和安卓客户端版本低于5.4.4版本不免流（不包含5.4.4）。</p>
<p>2)客户端启动广告、其他部分客户端广告、客户端内的直播业务的流量；</p>
<p>3)APP内添加并关注微博、微信、易信等好友；客户端内分享到其他APP；动态、私信等打开第三方链接；</p>
<p>4)第三方APP访问网易云阅读产生的流量不免流，如微博、微信内观看云阅读的内容等；</p>
<p>5)网易云阅读听书的订阅浏览、语音翻译、阅读圈部分视频、上传、评论产生的流量不包含在免流范围；</p>
<p>6)手机号码处于国际或港澳台地区漫游状态下产生的流量；</p>
<p>7)手机卡作为手机热点使用，或使用网络加速器、代理服务器、VPN等工具；</p>
<p>8)在无线上网卡、移动WIFI、MIFI、平板电脑（如iPad）等设备使用不免流量；</p>
<p>9)使用非iPhone、非android版本的客户端APP（如WindowsPhone）产生的流量；</p>
<p>10)双卡用户切换到其他手机卡使用流量；</p>
<p>11)iPhone用户需要关闭无线局域网助理（设置路径：设置-蜂窝移动网络-无线局域网助理）。</p>
<h4>8.易信免流范围：</h4>
<p>电信2G/3G/4G网络下，使用易信IOS和安卓客户端即时聊天、多人音视频通话和朋友圈内容浏览等免流量。</p>
<p>专属免流量不包括以下使用范围：</p>
<p>1)易信APP内打开打开或者跳转到任何第三方的链接的内容产生流量；</p>
<p>2)易信APP内使用点对点音视频通话（2方）、青果、点对点天翼视频通话（2方）、碰呗视频功能产生的流量；</p>
<p>3)客户端APP启动广告、大部分客户端广告的流量；</p>
<p>4)手机号码处于国际或港澳台地区漫游状态下产生的流量；</p>
<p>5)手机卡作为手机热点使用，或使用网络加速器、代理服务器、VPN等工具；</p>
<p>6)在无线上网卡、移动WIFI、MIFI、平板电脑（如ipad）等设备使用不免流量；</p>
<h4>网易系游戏类应用免流范围：</h4>
<h4>1)迷雾世界免流范围：</h4>
<p>电信2G/3G/4G网络下，使用游戏手机APP的流量基本全免。</p>
<p>专属免流量不包括以下使用范围：</p>
<p>a)游戏APP内客服专区的内容不免流；</p>
<p>b)第三方APP访问游戏产生的流量不免流，如迅游、UU等；</p>
<p>c)手机号码处于国际或港澳台地区漫游状态下产生的流量；</p>
<p>d)手机卡作为手机热点使用，或使用网络加速器、代理服务器、VPN等工具；</p>
<p>e)在无线上网卡、移动WIFI、MIFI、平板电脑（如ipad）等设备使用不免流量；</p>
<p>f)游戏类产品内相关论坛及朋友圈，部分图片和第三方直播视频产生的流量；</p>
<p>g)游戏类产品内相关录像上传及观看流量；</p>
<p>h)游戏中实时语音对话的流量。</p>
<h4>2)元气战姬学院免流范围：</h4>
<p>电信2G/3G/4G网络下，使用游戏手机APP的流量全免。</p>
<p>专属免流量不包括以下使用范围：</p>
<p>a)第三方APP访问游戏产生的流量不免流，如迅游、UU等；</p>
<p>b)手机号码处于国际或港澳台地区漫游状态下产生的流量；</p>
<p>c)手机卡作为手机热点使用，或使用网络加速器、代理服务器、VPN等工具；</p>
<p>d)在无线上网卡、移动WIFI、MIFI、平板电脑（如ipad）等设备使用不免流量；</p>
<p>e)游戏类产品内相关论坛及朋友圈，部分图片和第三方直播视频产生的流量；</p>
<p>f)游戏类产品内相关录像上传及观看流量；</p>
<p>g)游戏中实时语音对话的流量。</p>
<h4>3)坦克连免流范围：</h4>
<p>电信2G/3G/4G网络下，使用游戏手机APP的流量基本全免。</p>
<p>专属免流量不包括以下使用范围：</p>
<p>a)游戏中实时语音对话流量不免流；</p>
<p>b)第三方APP访问游戏产生的流量不免流，如迅游、UU等；</p>
<p>c)手机号码处于国际或港澳台地区漫游状态下产生的流量；</p>
<p>d)手机卡作为手机热点使用，或使用网络加速器、代理服务器、VPN等工具；</p>
<p>e)在无线上网卡、移动WIFI、MIFI、平板电脑（如ipad）等设备使用不免流量；</p>
<p>f)游戏类产品内相关论坛及朋友圈，部分图片和第三方直播视频产生的流量；</p>
<p>g)游戏类产品内相关录像上传及观看流量；</p>
<p>h)游戏中实时语音对话的流量。</p>
<h4>4)终结者2免流范围：</h4>
<p>电信2G/3G/4G网络下，使用游戏手机APP的流量基本全免。</p>
<p>专属免流量不包括以下使用范围：</p>
<p>a)游戏中补丁包下载不免流；</p>
<p>b)游戏中实时语音对话流量不免流；</p>
<p>c)对战直播流量不免流；</p>
<p>d)第三方APP访问游戏产生的流量不免流，如迅游、UU等；</p>
<p>e)手机号码处于国际或港澳台地区漫游状态下产生的流量；</p>
<p>f)手机卡作为手机热点使用，或使用网络加速器、代理服务器、VPN等工具；</p>
<p>g)在无线上网卡、移动WIFI、MIFI、平板电脑（如ipad）等设备使用不免流量；</p>
<p>h)游戏类产品内相关论坛及朋友圈，部分图片和第三方直播视频产生的流量。</p>
<h4>5)荒野行动免流范围：</h4>
<p>电信2G/3G/4G网络下，使用游戏手机APP的流量基本全免。</p>
<p>专属免流量不包括以下使用范围：</p>
<p>a)游戏中补丁包下载不免流；</p>
<p>b)游戏中实时语音对话流量不免流；</p>
<p>c)第三方APP访问游戏产生的流量不免流，如迅游、UU等；</p>
<p>d)手机号码处于国际或港澳台地区漫游状态下产生的流量；</p>
<p>e)手机卡作为手机热点使用，或使用网络加速器、代理服务器、VPN等工具；</p>
<p>f)在无线上网卡、移动WIFI、MIFI、平板电脑（如ipad）等设备使用不免流量；</p>
<p>g)游戏类产品内相关论坛及朋友圈，部分图片和第三方直播视频产生的流量；</p>
<p>h)游戏类产品内相关录像上传及观看流量。</p>
<h4>6)汉王纷争免流范围：</h4>
<p>电信2G/3G/4G网络下，使用游戏手机APP的流量基本全免。</p>
<p>专属免流量不包括以下使用范围：</p>
<p>a)更新补丁下载时产生的流量；</p>
<p>b)在无线上网卡、移动WIFI、MIFI、平板电脑（如ipad）等设备使用时</p>
<p>c)将手机号码作为手机热点使用时</p>
<p>d)使用网络加速器、代理服务器、VPN等工具时</p>
<p>e)在港澳台及国际地区使用时</p>
<p>f)通过APPSTORE或安卓市场等下载/更新应用时</p>
<p>g)应用内开机广告及第三方广告时产生的流量</p>
<p>h)应用中访问外部链接或转发到外部应用产生的流量</p>
<p>i)游戏类产品内相关论坛及朋友圈，图片和第三方直播视频产生的流量</p>
<p>j)游戏类产品内相关录像上传及观看产生的流量</p>
<p>k)游戏类产品从第三方APP访问产生的流量，如迅游、UU等</p>
<h4>7)决战！平安京/大航海之路免流范围：</h4>
<p>电信2G/3G/4G网络下，使用游戏手机APP的流量基本全免，包含补丁更新下载。</p>
<p>专属免流量不包括以下使用范围：</p>
<p>a)在无线上网卡、移动WIFI、MIFI、平板电脑（如ipad）等设备使用时</p>
<p>b)将手机号码作为手机热点使用时</p>
<p>c)使用网络加速器、代理服务器、VPN等工具时；</p>
<p>d)在港澳台及国际地区使用时；</p>
<p>e)通过APPSTORE或安卓市场等下载/更新应用时；</p>
<p>f)应用内开机广告及第三方广告时产生的流量；</p>
<p>g)应用中访问外部链接或转发到外部应用产生的流量；</p>
<p>h)游戏类产品内相关论坛及朋友圈，图片和第三方直播视频产生的流量；</p>
<p>i)游戏类产品内相关录像上传及观看产生的流量；</p>
<p>j)游戏类产品从第三方APP访问产生的流量，如迅游、UU等；</p>
<p>k)游戏类产品实时语音对话的流量。</p>
<h4>8)我的世界/天下/光明大陆/玩具大乱斗/格罗娅传奇免流范围：</h4>
<p>电信2G/3G/4G网络下，使用游戏手机APP的流量基本全免。</p>
<p>专属免流量不包括以下使用范围：</p>
<p>a)更新补丁下载时产生的流量；</p>
<p>b)在无线上网卡、移动WIFI、MIFI、平板电脑（如ipad）等设备使用时；</p>
<p>c)将手机号码作为手机热点使用时；</p>
<p>d)使用网络加速器、代理服务器、VPN等工具时；</p>
<p>e)在港澳台及国际地区使用时；</p>
<p>f)通过APPSTORE或安卓市场等下载/更新应用时；</p>
<p>g)应用内开机广告及第三方广告时产生的流量；</p>
<p>h)应用中访问外部链接或转发到外部应用产生的流量；</p>
<p>i)游戏类产品内相关论坛及朋友圈，图片和第三方直播视频产生的流量；</p>
<p>j)游戏类产品内相关录像上传及观看产生的流量；</p>
<p>k)游戏类产品从第三方APP访问产生的流量，如迅游、UU等；</p>
<p>l)游戏类产品实时语音对话的流量。</p>
<h4>9)阴阳师／镇魔曲／三国如龙传免流范围：</h4>
<p>电信2G/3G/4G网络下，使用阴阳师／镇魔曲／三国如龙传的流量免费。</p>
<p>专属免流量不包括以下使用范围：</p>
<p>a)在无线上网卡、移动WIFI、MIFI、平板电脑（如ipad）等设备使用时</p>
<p>b)将手机号码作为手机热点使用时</p>
<p>c)使用网络加速器、代理服务器、VPN等工具时</p>
<p>d)在港澳台及国际地区使用时</p>
<p>e)通过APPSTORE或安卓市场等下载/更新应用时</p>
<p>f)应用内开机广告及第三方广告时产生的流量</p>
<p>g)应用中访问外部链接或转发到外部应用产生的流量</p>
<p>h)游戏类产品内相关论坛及朋友圈，图片和第三方直播视频产生的流量</p>
<p>i)游戏类产品内相关录像上传及观看产生的流量</p>
<p>j)游戏类产品从第三方APP访问产生的流量，如迅游、UU等</p>
<p>k)游戏中实时语音对话的流量；</p>
<h4>10)梦幻西游／大话西游／倩女幽魂／率土之滨免流范围：</h4>
<p>电信2G/3G/4G网络下，使用梦幻西游／大话西游／倩女幽魂／率土之滨的流量免费，更新下载的流量也全免。</p>
<p>专属免流量不包括以下使用范围：</p>
<p>a)在无线上网卡、移动WIFI、MIFI、平板电脑（如ipad）等设备使用时</p>
<p>b)将手机号码作为手机热点使用时</p>
<p>c)使用网络加速器、代理服务器、VPN等工具时</p>
<p>d)在港澳台及国际地区使用时</p>
<p>e)通过APPSTORE或安卓市场等下载/更新应用时</p>
<p>f)应用内开机广告及第三方广告时产生的流量</p>
<p>g)应用中访问外部链接或转发到外部应用产生的流量</p>
<p>h)游戏类产品内相关论坛及朋友圈，图片和第三方直播视频产生的流量</p>
<p>i)游戏类产品内相关录像上传及观看产生的流量</p>
<p>j)游戏类产品从第三方APP访问产生的流量，如迅游、UU等</p>
<h4>11)其他游戏应用专属免流量不包括以下使用范围：</h4>
<p>a)游戏类产品从第三方APP访问产生的流量，如迅游、UU等；</p>
<p>b)游戏类产品内相关论坛及朋友圈，部分图片和第三方直播视频产生的流量；</p>
<p>c)游戏类产品内相关录像上传及观看流量；</p>
<p>d)游戏中实时语音对话的流量；</p>
<p>e)游戏的补丁下载产生的流量。</p>
<h4>(三)头条系定向流量包：</h4>
<p>应用包含：今日头条、今日头条lite版（今日头条极速版）、西瓜视频、火山小视频（抖音火山版）、抖音短视频、抖音极速版、皮皮虾、懂车帝、半次元国内视频定向流量。</p>
<p>1.适用于中国电信除时长型套餐、畅享套餐等已明确不允许订购流量包的套餐以外的所有手机用户开放。</p>
<p>2.今日头条系定向流量不包括以下使用范围： </p>
<p>1)上述APP内的弹幕加载、第三方广告、下载、缓存、在线观看第三方视频等产生的流量。</p>
<p>2)使用头条系产品客户端开直播产生的流量；</p>
<p>3)在无线上网卡、移动WIFI、MIFI、平板电脑（如ipad）等设备使用；</p>
<p>4)手机号码作为手机热点使用；</p>
<p>5)打开登录头条系产品时加载图片、文字等产生的流量。</p>
<p>6)使用字节系产品拍摄上传功能，上传分享至非字节系应用不免流；</p>
<p>7)使用字节系产品进行视频聊天、语音聊天不免流。</p>
<p></p>
<h4>(四)阿里系定向流量说明如下：</h4>
<p>包含应用：优酷视频</p>
<p>优酷视频免流说明：</p>
<p>1)优酷视频定向流量范围：电信4G、3G、2G网络下，通过优酷APP观看优酷视频、直播（非来疯直播）、视频缩略图、视频广告及缓存视频产生的流量免费。</p>
<p>2)国内优酷视频定向流量不包括以下使用范围：</p>
<p>a)优酷客户端内其它图片（视频缩略图除外）、文字、弹幕加载、来疯直播类视频；上传视频；打开登录优酷视频时加载图片、文字等产生的流量。</p>
<p>b)第三方广告，在线观看、下载、缓存、上传第三方视频操作（第三方视频：爱奇艺、腾讯视频等）。</p>
<p>c)在无线上网卡、移动WIFI、MIFI、平板电脑（如ipad）等设备使用。</p>
<p>d)手机号码作为手机热点使用。</p>
<h4>(五)腾讯视频定向流量包说明如下：</h4>
<p>1)腾讯视频定向流量范围：电信4G、3G、2G网络下，通过腾讯APP观看腾讯视频等相关内容产生的流量免费。</p>
<p>2)国内腾讯视频定向流量不包括以下使用范围：</p>
<p>a)腾讯客户端内其它图片（视频缩略图除外）、文字、弹幕加载，上传及下载视频；打开登录腾讯视频时加载图片、文字等产生的流量。</p>
<p>b)第三方广告，在线观看、下载、缓存。</p>
<p>c)在无线上网卡、移动WIFI、MIFI、平板电脑（如ipad）等设备使用。</p>
<p>d)手机号码作为手机热点使用。</p>
<h4>(六)哔哩哔哩定向流量包说明如下：</h4>
<p>1.哔哩哔哩定向流量包含以下范围：</p>
<p>观看视频、观看直播、图片、弹幕、视频缓存、音频缓存、视频上传、音频播放、安卓客户端内版本升级、安卓客户端内游戏下载。</p>
<p>注：B站享受定向流量服务前需先至对应APP进行绑定激活</p>
<p>激活路径：哔哩哔哩APP-我的-看视频免流量（IOS系统）/免流量服务。（Android）-电信-底部点我激活电信免流卡</p>
<p>2.不包括以下使用范围：</p>
<p>1)使用本免流量服务需要将哔哩哔哩客户端升级到5.45或5.45以上版本，并确保是官方正版APP。</p>
<p>2) 客户端内打开网页（如话题页、活动页、专题页等网页）不支持免流量</p>
<p>哔哩哔哩APP内漫画分区暂时不支持免流。</p>
<p>3)在无线上网卡、移动WIFI、MIFI、平板电脑（如ipad）等设备使用不支持免流量。</p>
<p>4)手机号码作为手机热点使用时，不支持免流量。</p>
<p>5)需要使用3GNET接入点访问本产品，使用其他接入点（包括3GWAP）不支持免流。3GNET接入点支持使用3G/4G网络访问，2G 用户无法使用此产品</p>
<p>使用网络加速器、代理服务器、VPN等工具无法免流。</p>
<p>6)请在WIFI功能关闭下使用免流功能，避免WIFI和移动网络频繁切换导致免流量服务启动失败。</p>
<p>7)在中国港、澳、台及国际地区使用哔哩哔哩客户端不支持免流。</p>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>